import * as routeConstants from "./RouteConstants";
import * as accessScopeConstants from "./AccessScopeConstants";
import * as menuConstants from "./MenuConstants";
import * as learningObjectConstants from "./LearningObjectConstants";
import * as globalConstants from "./GlobalConstants";
import * as learningProgramConstants from "./LearningProgramConstants";
import * as notificationConstants from "./NotificationConstants";
import * as integrationConstants from "./IntegrationConstants";
import * as rewardConstants from "./RewardConstants";

export const RouteConstants = routeConstants;
export const AccessScopeConstants = accessScopeConstants;
export const MenuConstants = menuConstants;
export const LearningObjectConstants = learningObjectConstants;
export const GlobalConstants = globalConstants;
export const LearningProgramConstants = learningProgramConstants;
export const NotificationConstants = notificationConstants;
export const IntegrationConstants = integrationConstants;
export const RewardConstants = rewardConstants;
